export enum OrderStatusValue {
    Created = "Order Created",
    Failed = "Order Failed",
    Rejected = "Order Rejected",
    Processing = "Payment Received",
    Processed = "Order Processed",
    Completed = "Order Settled",
    Refund = "Refund Processed"
}

export enum OrderStages {
    OrderCreated = "Order Created",
    OrderFailed = "Order Failed",
    OrderRejected = "Order Rejected",
    PaymentReceived = "Payment Received",
    OrderProcessed = "Order Processed",
    OrderSettled = "Order Settled",
    RefundProcessed = "Refund Processed"
}

enum OrderStatusLabel {
    Created = "Order Created",
    Failed = "Order Failed",
    Rejected = "Order Rejected",
    Processing = "Payment Received",
    Processed = "Order Processed",
    Completed = "Order Settled",
    Refund = "Refund Processed"
}

const ERROR_COLOR = "red";
const BLUE_COLOR = "blue";
const GREEN_COLOR = "green";

enum OrderStatusColor {
    Created = "orange",
    Failed = ERROR_COLOR,
    Rejected = ERROR_COLOR,
    Processing = BLUE_COLOR,
    Processed = BLUE_COLOR,
    Completed = GREEN_COLOR,
    Refund = GREEN_COLOR
}

export const ORDER_STATUS = {
    [OrderStatusValue.Created]: {
        value: OrderStatusValue.Created,
        label: OrderStatusLabel.Created,
        color: OrderStatusColor.Created,
    },
    [OrderStatusValue.Rejected]: {
        value: OrderStatusValue.Rejected,
        label: OrderStatusLabel.Rejected,
        color: OrderStatusColor.Rejected,
    },
    [OrderStatusValue.Failed]: {
        value: OrderStatusValue.Failed,
        label: OrderStatusLabel.Failed,
        color: OrderStatusColor.Failed,
    },
    [OrderStatusValue.Processing]: {
        value: OrderStatusValue.Processing,
        label: OrderStatusLabel.Processing,
        color: OrderStatusColor.Processing,
    },
    [OrderStatusValue.Processed]: {
        value: OrderStatusValue.Processed,
        label: OrderStatusLabel.Processed,
        color: OrderStatusColor.Processed,
    },
    [OrderStatusValue.Completed]: {
        value: OrderStatusValue.Completed,
        label: OrderStatusLabel.Completed,
        color: OrderStatusColor.Completed,
    },
    [OrderStatusValue.Refund]: {
        value: OrderStatusValue.Refund,
        label: OrderStatusLabel.Refund,
        color: OrderStatusColor.Refund,
    },
};